import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';

/**
 * Yes/no buttons for an open `confirm` question. There is deliberately no free-text
 * input here — the backend's third answer branch (a correction, e.g. "nein, ich
 * meinte Kokosmilch") is answered through the panel's ordinary message input, which
 * stays enabled while a confirm question is open. This mirrors how a free-text
 * `clarify` question already relies on the same input rather than a dedicated field.
 */
@Component({
  selector: 'app-confirm-action',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-action.component.html',
})
export class ConfirmActionComponent {
  @Input() answer?: 'yes' | 'no';
  /** Label for the affirmative button/answer — defaults to the generic "Ja", but a
   *  caller can supply an action-specific label (e.g. "Rezept speichern" for
   *  `create_recipe`). "Nein" is intentionally not configurable — every action type
   *  keeps the same generic rejection wording. */
  @Input() confirmLabel = 'Ja';
  @Output() answered = new EventEmitter<'yes' | 'no'>();

  get isAnswered(): boolean {
    return this.answer != null;
  }

  choose(value: 'yes' | 'no'): void {
    if (this.isAnswered) return;
    this.answered.emit(value);
  }
}
